import { Column } from 'react-table'
import { propertyAccessor } from '../../../common/components/properties/Properties'
import {
  format,
  orderCmrDataTooltip,
  orderSalesOrderNumber,
  orderShipToTooltip,
  plannedUnits,
  shipmentLinks,
} from '../../../common/utils/formatter'
import { EnrichedDeliveryNote } from '../../../generated/graphql'

export const ordersTableColumns: Column[] = [
  {
    Header: 'Delivery Note',
    accessor: propertyAccessor('deliveryNote.fulfillmentRequestHeader.fulfillmentRequestNumber'),
  },
  {
    Header: 'Sales Order',
    accessor: (order: EnrichedDeliveryNote) => orderSalesOrderNumber(order),
  },
  {
    Header: 'Packlist',
    accessor: propertyAccessor('shipments.packlistNumber'),
    Cell: format(shipmentLinks),
  },
  {
    Header: 'CMR',
    accessor: (order: EnrichedDeliveryNote) => orderCmrDataTooltip(order),
  },
  {
    Header: 'Shipping Point',
    accessor: propertyAccessor('deliveryNote.fulfillmentRequestHeader.shippingPointCode'),
  },
  {
    Header: 'Ship To',
    accessor: (order: EnrichedDeliveryNote) => orderShipToTooltip(order),
  },
  {
    Header: '# Units',
    accessor: (order: EnrichedDeliveryNote) => plannedUnits(order),
  },
]
